<template>
    <div class="bg-nomad-900 rounded-xl p-6 min-w-0">
        <h1 class="text-lg font-semibold text-white mb-4">Featured content</h1>
        <div v-if="contents.length" class="drag-container">
            <draggable :list="contents" group="songs" class="space-y-1" @change="handleDragChange" item-key="id">
                <div class="flex items-center gap-3 w-full bg-nomad-800 rounded-lg px-3 py-2.5 text-white" v-for="element in contents"
                    v-bind:key="element.id">
                    <span class="icon-menu shrink-0 cursor-move text-nomad-300"></span>
                    <span class="min-w-0 flex-1 truncate">{{ element.name }} <span class="text-nomad-200">{{ element.artist.name }}</span></span>
                    <button class="icon-x shrink-0 rounded-md p-1 text-nomad-200 hover:bg-nomad-700 hover:text-white" @click.prevent="removeContent(element.id)"></button>
                </div>
            </draggable>
        </div>
        <div class="relative mt-4">
            <div class="flex items-center gap-3">
                <input type="text" v-model="query" class="w-full rounded-lg bg-nomad-800 border border-nomad-700 text-white placeholder:text-nomad-400 focus:border-nomad-accent focus:ring-nomad-accent" placeholder="Search songs" />
                <button @click.prevent="saveOptions"
                    class="shrink-0 rounded-lg bg-nomad-accent text-nomad-900 font-semibold px-4 h-11 hover:bg-nomad-accent/80">Save</button>
            </div>
            <ul class="absolute inset-x-0 top-full z-20 mt-2 max-h-72 overflow-y-auto rounded-lg bg-nomad-800 text-white shadow-xl" v-if="results.songs">
                <li v-for="song in results.songs" v-bind:key="song.id"><button @click.prevent="selectContent(song)"
                        class="flex w-full items-center gap-2 text-left p-2 hover:bg-nomad-700"><span
                            class="icon-music text-nomad-accent"></span><span class="min-w-0 truncate">{{ song.name }} <span class="text-nomad-200">{{ song.artist.name
                            }}</span></span></button></li>
                <li v-for="artist in results.artists" v-bind:key="artist.id"><button
                        class="flex w-full items-center gap-2 text-left p-2 hover:bg-nomad-700"><span
                            class="icon-user text-nomad-accent"></span>{{ artist.name }}</button></li>
            </ul>
        </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { debounce, remove, take } from '@/utils/helpers';
import { VueDraggableNext } from 'vue-draggable-next'
import axios from 'axios';

export default {
    data() {
        return {
            query: null,
            contents: [],
            results: {}
        }
    },
    components: {
        draggable: VueDraggableNext,
    },
    mounted() {
        this.getOptions()
    },
    methods: {
        getContent() {
            if (this.query) {
                axios
                    .get("/api/backstage/admin-search?q=" + this.query)
                    .then((response) => (this.results = response.data));
            }
        },
        selectContent(content) {
            this.contents.push(content);
            this.results = {};
            this.query = null
        },
        saveOptions() {
            axios.post('/api/backstage/options', { 'option_key': 'HOMEFEATURED', 'option_value': take(this.contents, 6) })
        },
        getOptions() {
            axios.get('/api/backstage/options/HOMEFEATURED')
                .then(response => this.contents = response.data.option_value)
        },
        removeContent(id) {
            remove(this.contents, function (n) {
                return n.id === id
            })
        },
        handleDragChange(event) {
            // Handle drag change if needed
            console.log('Drag change:', event)
        }
    },
    watch: {
        query: debounce(function (newval, oldval) {
            this.getContent(newval);
        }, 1000),
    },
}
</script>
<style scoped>
.drag-container {
    min-height: 0;
}
</style>